import "./Carousel.scss";
import { Link, useNavigate } from "react-router-dom";
import { shortenText } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../../redux/features/auth/authSlice";

function removeHTMLTags(input) {
  const regex = /<[^>]+>/g;
  return input.replace(regex, "");
}

const CarouselItem = ({ url, category, title, post }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const desc = removeHTMLTags(title);

  const dispatch = useDispatch();
  const addWishlist = async (post) => {
    const postData = {
      postId: post._id,
    };
    await dispatch(addToWishlist(postData));
  };
  return (
    <div className="carouselItem" key={post._id}>
      <Link to={`/page/${post.slug}`}>
        <img className="product--image" src={url} alt="post" />
        <h4>{shortenText(category, 18)}</h4>
        <p className="--mb">{shortenText(desc, 30)}</p>
      </Link>
      <button
        className="--btn --btn-primary --btn-block"
        onClick={
          !isLoggedIn ? () => navigate("/login") : () => addWishlist(post)
        }
      >
        Add To Read Later
      </button>
    </div>
  );
};
export default CarouselItem;
